export default [{
    title: "sistema_documento.titulo",
    fontIcon: "cogs",
    resource: "Sistema Documentos",
    action: "ver-sistema-documentos",
    children: [
        {
            title: "Configuracion",
            icon: "SettingsIcon",
            resource: "Sistema Documentos",
            action: "ver-sistema-documentos-configuracion",
            children: [{
                route: "configuracion-permisos-sistemaDocumentos",
                title: "sistema_documento.configuracion.permiso_departamento.titulo",
                fontIcon: "clipboard-list",
                resource: "Sistema Documentos",
                action: "ver-sistema-documentos-configuracion-permisos",
            }]
        },
        {
            title: "Transacciones",
            fontIcon: "exchange-alt",
            resource: "Sistema Documentos",
            action: "ver-sistema-documentos-transacciones",
            children: [
                {
                    title: "Organigrama",
                    fontIcon: "sitemap",
                    resource: "Sistema Documentos",
                    action: "ver-sistema-documentos-organigrama",
                    children: [{
                            title: "sistema_documento.transacciones.org_institucional.titulo",
                            fontIcon: "sitemap",
                            resource: "Sistema Documentos",
                            action: "ver-sistema-documentos-organigrama-institucional",
                            route: "organigrama-institucional",
                        },
                        {
                            title: "sistema_documento.transacciones.org_jerarquia.titulo",
                            fontIcon: "sitemap",
                            resource: "Sistema Documentos",
                            action: "ver-sistema-documentos-organigrama-departamental",
                            route: "organigrama-departamental",
                        },
                    ],
                },
                {
                    title: "Procesos",
                    icon: "CpuIcon",
                    resource: "Sistema Documentos",
                    action: "ver-sistema-documentos-procesos",
                    children: [{
                            title: "sistema_documento.transacciones.manual_procedimiento.titulo",
                            fontIcon: "file-word",
                            resource: "Sistema Documentos",
                            route:'manual-procedimientos',
                            action: "ver-sistema-documentos-procedimientos",
                        },
                        {
                            title: "sistema_documento.transacciones.manual_funcion.titulo",
                            fontIcon: "file-word",
                            resource: "Sistema Documentos",
                            route:'manual-funciones',
                            action: "ver-sistema-documentos-funciones",
                        },
                        {
                            title: "sistema_documento.transacciones.instructivo.titulo",
                            fontIcon: "file-word",
                            resource: "Sistema Documentos",
                            route: "instructivos",
                            action: "ver-sistema-documentos-instructivos",
                        },
                    ]
                },
            ]
        },
        {
            title: "Mantenimiento",
            icon: "EditIcon",
            resource: "Sistema Documentos",
            action: "ver-sistema-documentos-mantenimiento",
            children: [{
                route: "mantenimiento-procesos",
                title: "sistema_documento.mantenimiento.revision.titulo",
                fontIcon: "file-circle-check",
                resource: "Sistema Documentos",
                action: "ver-sistema-documentos-mantenimiento-revisiones",
            },
            ]
        },
        {
            title: "Informes",
            fontIcon: "file-prescription",
            resource: "Sistema Documentos",
            action: "ver-sistema-documentos-informes",
            children: [{
                title: "sistema_documento.informes.vision_mision.titulo",
                fontIcon: "info",
                resource: "Sistema Documentos",
                route: "mision-vision",
                action: "ver-sistema-documentos-mision-vision",
            },]
        },
    ]
}, ]